const initDateRangeState = {
  startDate: null,
  endDate: null,
  key: 'selection',
};

export default initDateRangeState;
